import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.black,
  tileBgColor: colors.white,
  iconBgColor: colors.black
};
export default imageGallery;